<template>
  <v-footer class="footer page-footer" :app="!user">
    <div v-if="!mobile" class="footer__content">
      <v-layout align-center row fill-height>
        <div class="footer__content__text">
          {{ config.texts.footerCopyright }}
        </div>
        <div class="footer__content__brand-website">
          <a :href="config.texts.footerBrandWebSite">{{
            config.texts.footerBrandWebSite
          }}</a>
        </div>
        <div class="footer__content__social">
          <v-hover v-for="social in socialLinks" :key="social.name">
            <v-btn
              icon
              slot-scope="{ hover }"
              :color="
                social.bgColorHover && hover
                  ? social.bgColorHover
                  : social.bgColor
              "
              :href="social.link"
              target="_blank"
              class="footer__social-button"
            >
              <v-icon
                :color="
                  social.iconColorHover && hover
                    ? social.iconColorHover
                    : social.iconColor
                "
                >bexsicon-{{ social.icon }}</v-icon
              >
            </v-btn>
          </v-hover>
        </div>
        <div class="footer__content__bexs-brand">
          Powered by <img src="@/assets/img/bexs_logo.png" />
        </div>
        <router-link
          tag="button"
          :to="{ name: 'credits' }"
          class="payment-slip__button btn btn-primary py-0"
        >
          <span>{{ $t('app.credits') }}</span>
        </router-link>
      </v-layout>
    </div>

    <v-layout
      v-else
      class="footer__mobile-content"
      row
      wrap
      align-end
      justify-space-between
    >
      <v-flex xs9 sm4 mb-1>
        {{ config.texts.footerCopyright }}
      </v-flex>
      <v-flex xs3 sm2 class="footer__mobile-content__bexs-brand">
        <span>Powered by </span><img src="@/assets/img/bexs_logo.png" />
      </v-flex>
      <v-flex xs7 sm3 class="footer__content__social">
        <v-layout align-center justify-space-between row>
          <v-hover v-for="social in socialLinks" :key="social.name">
            <v-btn
              icon
              slot-scope="{ hover }"
              :color="
                social.bgColorHover && hover
                  ? social.bgColorHover
                  : social.bgColor
              "
              :href="social.link"
              target="_blank"
              class="footer__social-button"
            >
              <v-icon
                :color="
                  social.iconColorHover && hover
                    ? social.iconColorHover
                    : social.iconColor
                "
                >bexsicon-{{ social.icon }}</v-icon
              >
            </v-btn>
          </v-hover>
        </v-layout>
      </v-flex>
      <v-flex xs4 sm2 class="footer__mobile-content__brand-website">
        <a
          target="_blank"
          :href="'http://' + config.texts.footerBrandWebSite"
          >{{ config.texts.footerBrandWebSite }}</a
        >
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
import { CONFIG } from '../../utils/constants';

export default {
  name: 'footer-bar',
  computed: {
    config() {
      return this.$store.getters[CONFIG.GET];
    },
  },
  data() {
    return {
      socialLinks: [],
    };
  },
  created() {
    this.socialLinks = this.config.socialLinks || [];
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.footer {
  margin: 1em 0 0.5em;
  padding: 1em;
  font-size: 0.7em;
  background-color: #fff !important;

  @include breakpoint(mobile) {
    font-size: 0.6em;
    height: 60px !important;
    margin: 0;
    padding: 0 1em !important;

    @include breakpoint(tablet) {
      height: 20px !important;
      padding: 1em;
    }
  }

  &__social-button {
    width: 28px;
    height: 28px;
    border-radius: 30% !important;
    .v-icon {
      font-size: 1.2em;
    }

    @include breakpoint(mobile) {
      width: 24px;
      height: 24px;
      margin: 0;
      .v-icon {
        font-size: 1em;
      }
    }
  }
  &__content {
    padding: 1em 0;
    display: flex;
    width: 100%;
    max-width: 1366px;
    margin: 0 auto;

    @include breakpoint(mobile) {
      display: none;
    }

    &__text {
      flex: 1;
    }

    &__brand-website {
      border-left: 1px solid var(--border-light-color);
      flex: 0.55;
      padding-left: 1em;
      height: 15px;
      a {
        color: var(--brand-color) !important;
        text-decoration: none !important;
      }
    }

    &__bexs-brand {
      flex: 0.3;
      text-align: right;
      color: var(--label-color);

      img {
        width: 25%;
        padding: 0 0.5em;

        @include breakpoint(tablet) {
          width: 50px;
        }
        @include breakpoint(not-mobile) {
          width: 50px;
        }
      }
    }
  }

  &__mobile-content {
    padding: 0em;

    @include breakpoint(not-mobile) {
      display: none;
    }
    @media print {
      padding: 0;
    }
    &__brand-website {
      a {
        color: var(--brand-color) !important;
        text-decoration: none !important;
      }
    }

    &__bexs-brand {
      text-align: right;
      color: var(--label-color);

      img {
        width: 45%;

        @include breakpoint(tablet) {
          width: 50px;
        }
        @include breakpoint(not-mobile) {
          width: 50px;
        }
        @media print {
          width: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/layout/Footer.vue